import { __require as r } from "./td-longtail-vue-components279.js";
var a = r();
export {
  a as v
};
